


import {observable, IObservableArray} from "mobx";

 
export class RemoveQuery {     
	guid: string = "";    
	lastModified: Date;
}
 
export class InputText {     
	@observable label: string = "";    
	@observable isMultiLine: boolean;    
	@observable value: string = "";    
	@observable valueNeedsTranslation: boolean;    
	@observable isReadOnly: boolean;    
	@observable regex: string = "";    
	@observable placeHolder: string = "";    
	@observable isValid: boolean;    
	@observable validationMessage: string = "";
}
 
export class InputNumber {     
	@observable label: string = "";    
	@observable value: number;    
	@observable isReadOnly: boolean;    
	@observable isValid: boolean;    
	@observable validationMessage: string = "";    
	@observable placeHolder: string = "";
}
 
export class InputFile {     
	@observable label: string = "";    
	@observable value: string = "";    
	@observable previewUrl: string = "";    
	@observable mimeTypes: string = "";    
	@observable isReadOnly: boolean;    
	@observable isValid: boolean;    
	@observable validationMessage: string = "";
}
 
export class InputDate {     
	@observable label: string = "";    
	@observable value: Date;    
	@observable isReadOnly: boolean;    
	@observable isValid: boolean;    
	@observable validationMessage: string = "";
}
 
export class InputBoolean {     
	@observable label: string = "";    
	@observable value: boolean;    
	@observable isReadOnly: boolean;    
	@observable isValid: boolean;    
	@observable validationMessage: string = "";    
	@observable tooltip: string = "";
}
 
export class InputChoice {     
	@observable label: string = "";    
	@observable value: string = "";    
	values: IObservableArray<ValueCaptionPair> = observable.array([]);    
	@observable isReadOnly: boolean;    
	@observable isValid: boolean;    
	@observable validationMessage: string = "";
}
 
export class ValueCaptionPair {     
	@observable value: string = "";    
	@observable caption: string = "";
}
 
export class PrivilegeMembership {     
	@observable name: string = "";    
	@observable displayName: string = "";    
	@observable isExplicitMemberOf: boolean;    
	@observable isImplicitMemberOf: boolean;    
	@observable isReadOnly: boolean;
}
 
export class FileNote {     
	@observable guid: string = "";    
	@observable fileId: string = "";    
	@observable topicUri: string = "";    
	@observable pageNr: number;    
	@observable note: string = "";    
	@observable creator: string = "";    
	@observable lastModified: Date;
}
 
export class LanguageInfo {     
	@observable name: string = "";    
	@observable caption: string = "";    
	@observable region: string = "";
}


export enum FilterMode {
  Single = 0,
  MultipleAnd = 1,
  MultipleOr = 2,
}

export enum InputType {
  InputText = 0,
  InputChoice = 1,
  InputDate = 2,
  InputNumber = 3,
  InputHierarchy = 4,
  InputDocumentLink = 5,
}

export enum BooleanChoice {
  None = 0,
  True = 1,
  False = 2,
}


export function _ignoreCompilerError_TS6133(x: any) : boolean {
  return (x instanceof InputText) || 
		 (x instanceof InputBoolean) || 
		 (x instanceof InputChoice) || 
		 (x instanceof InputDate) ||
		 (x instanceof InputFile) || 
		 (x instanceof PrivilegeMembership) || 
		 (x instanceof FileNote) || 
		 (x instanceof LanguageInfo) || 
		 (x instanceof RemoveQuery);
}

